import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import CurrencyInput from 'react-currency-input-field';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { membresiaCliente } from '../../actions/clientes';
import { buscarMembresiasConfiguracion } from '../../actions/configuracion';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const GestionarMembresia = ({ membresia, reestablecerMembresia }) => {

    const dispatch =  useDispatch();

    const { listado } = useSelector(state => state.configuracion.membresias);

    const [membresiaActualData, setMembresiaActualData] = useState({
        id: null, 
        id_cliente: null, 
        id_membresia: null, 
        nombre: null, 
        status: null, 
        total: null, 
        metodo: null, 
        fecha_inicio: null, 
        fecha_fin: null
    });

    const [membresiaData, setMembresiaData] = useState(null);
    const [membresiasFilter, setMembresiasFilter] = useState([]);

    const [metodoData, setMetodoData] = useState(null);
    const metodosFilter = [
        { value: 0, label: 'Efectivo' },
        { value: 1, label: 'Tarjeta' },
        { value: 2, label: 'Transferencia' }
    ];

    const [membresiaModal, setMembresiaModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided, 
        }),
        control: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Gestionar membresia */
    const handleAbrir = () => {
        dispatch(buscarMembresiasConfiguracion());
    }

    const handleSelectMembresia = (option) => {
        setMembresiaData(option);

        setMembresiaActualData({
            ...membresiaActualData,
            id_membresia: option != null ? option.value : null, 
            total: option != null ? option.precio : null
        });
    }

    const handleNumberChange = (value) => {
        setMembresiaActualData({
            ...membresiaActualData,
            total: value || ''
        });
    }

    const handleSelectMetodo = (option) => {
        setMetodoData(option);

        setMembresiaActualData({
            ...membresiaActualData,
            metodo: option != null ? option.value : null
        });
    }

    const handleDatePicker = (name, value) => {
        setMembresiaActualData({
            ...membresiaActualData,
            [name]: value
        });
    }

    const handleProcesar = async () => {
        await setStatusProcesar(true);
        
        await dispatch(membresiaCliente(membresiaActualData));

        await handleCerrar(null);
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setMembresiaActualData({
                id: null, 
                id_cliente: null, 
                id_membresia: null, 
                nombre: null, 
                status: null, 
                total: null, 
                metodo: null, 
                fecha_inicio: null, 
                fecha_fin: null
            });

            setMembresiaData(null);
            setMetodoData(null);

            reestablecerMembresia(null);

            setMembresiaModal(false);
        }
    }

    useEffect(() => {
        if(membresia){            
            setMembresiaActualData({
                ...membresiaActualData, 
                id: membresia._id, 
                id_cliente: membresia.id_cliente, 
                id_membresia: membresia.id_membresia, 
                nombre: membresia.nombre, 
                status: membresia.status
            });

            setMembresiaModal(true);
        }
    }, [membresia]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado?.length; i++) {
            options.push({ value: listado[i]._id, label: listado[i].nombre, precio: listado[i].precio });
        }

        setMembresiasFilter(options);
    }, [listado]);

    return (
        <Modal size={membresiaActualData.status == 0 ? 'md' : 'lg'} show={membresiaModal} backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Gestionar membresía</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    membresiaActualData.status == 0 ?
                        <p>¿Deseas cancelar tu membresía {membresiaActualData.nombre}?</p>
                    :
                        <p>Actualmente no tiene ninguna membresía activa ¿Deseas contratar una?</p>
                }
                
                {
                    membresiaActualData.status != 0 ?
                        <div className="row">
                            <div className="col-md-4 form-group mb-3">
                                <div className="input-group h-100">
                                    <Select
                                        id="id_membresia"
                                        name="id_membresia"
                                        className="select-group"
                                        classNamePrefix="react-select"
                                        placeholder="Membresía"
                                        isClearable={true}
                                        options={membresiasFilter}
                                        value={membresiaData}
                                        onChange={(value) => handleSelectMembresia(value)}
                                        menuPortalTarget={document.body}
                                        components={{ ValueContainer: CustomValueContainer }}
                                        styles={{ ...styles_select }}
                                    />
                                </div>
                            </div>

                            <div className="col-md-4 form-group mb-3">
                                <div className="input-group">
                                    <div className="form-floating">
                                        <CurrencyInput
                                            id="total"
                                            name="total"
                                            className="form-control text-center"
                                            value={membresiaActualData.total || ''}
                                            decimalsLimit={2}
                                            groupSeparator=","
                                            decimalSeparator="."
                                            onValueChange={(value) => handleNumberChange(value)}
                                        />
                                        <label htmlFor="total">Total a cobrar</label>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 form-group mb-3">
                                <div className="input-group h-100">
                                    <Select
                                        id="metodo"
                                        name="metodo"
                                        className="select-group"
                                        classNamePrefix="react-select"
                                        placeholder="Método de pago"
                                        isClearable={true}
                                        options={metodosFilter}
                                        value={metodoData}
                                        onChange={(value) => handleSelectMetodo(value)}
                                        menuPortalTarget={document.body}
                                        components={{ ValueContainer: CustomValueContainer }}
                                        styles={{ ...styles_select }}
                                    />
                                </div>
                            </div>

                            <div className="col-md-6 form-group mb-3">
                                <div className="input-group">
                                    <div className="form-floating">
                                        <DatePicker
                                            id="fecha_inicio"
                                            name="fecha_inicio"
                                            className="form-control text-center input-datepícker"
                                            dateFormat="dd/MM/yyyy"
                                            locale="es-ES"
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            selected={ membresiaActualData.fecha_inicio != null ? new Date(membresiaActualData.fecha_inicio) : '' }
                                            onChange={ date => handleDatePicker('fecha_inicio', date) }
                                        />
                                        <label className="label-datepicker" htmlFor="fecha_inicio">Fecha de inicio</label>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 form-group mb-3">
                                <div className="input-group">
                                    <div className="form-floating">
                                        <DatePicker
                                            id="fecha_fin"
                                            name="fecha_fin"
                                            className="form-control text-center input-datepícker"
                                            dateFormat="dd/MM/yyyy"
                                            locale="es-ES"
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            selected={ membresiaActualData.fecha_fin != null ? new Date(membresiaActualData.fecha_fin) : '' }
                                            onChange={ date => handleDatePicker('fecha_fin', date) }
                                        />
                                        <label className="label-datepicker" htmlFor="fecha_fin">Fecha de vencimiento</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    :
                        null
                }
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>

                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default GestionarMembresia;